import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { RaffleService } from 'src/app/data/service/raffle.service';
import { RaffleBasePage } from '../../raffle-base-page';
import { ServiceHelper } from 'src/app/core/helper/services.helper';

@Component({
  selector: 'app-missing-steps-popover',
  templateUrl: './missing-steps-popover.component.html',
  styleUrls: ['./missing-steps-popover.component.scss'],
})
export class MissingStepsPopoverComponent extends RaffleBasePage implements OnInit {

  constructor(
    raffleService: RaffleService,
    private popoverCtrl: PopoverController,
  ) {
    super(raffleService);
  }

  ngOnInit() {
    this.loadData();
  }

  goToPage(pg: string = 'detail') {
    ServiceHelper.navCtrl.navigateForward(`/admin/${this.raffle.accessCode}/setup/${pg}`);
    this.dismissPopover();
  }

  async dismissPopover() {
    await this.popoverCtrl.dismiss();
  }
}
